module.exports = __webpack_public_path__ + "img/BPPMP9.19e03af2.png";